import { GlobalAxios } from "../axios/axios-config";
import { IExecuteSqlParams, IExecuteSqlReturn } from "../models/execute-sql";

const EXECUTE_SQL_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/ExecuteSql";

export const executeSql = (params: IExecuteSqlParams) => {
  return GlobalAxios.post<IExecuteSqlReturn>(EXECUTE_SQL_ROUTE, params);
};
